var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutomatedCampaignsImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 332,
    viewBox: "0 0 500 332",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_395_153)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_395_153",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 498,
    height: 332
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M498.962 0H1.03711V331.95H498.962V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_395_153)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_395_153",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 498,
    height: 332
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M498.962 0H1.03711V331.95H498.962V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_395_153)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M231.938 425.672C349.484 425.672 444.774 330.382 444.774 212.836C444.774 95.29 349.484 0 231.938 0C114.392 0 19.1016 95.29 19.1016 212.836C19.1016 330.382 114.392 425.672 231.938 425.672Z",
    fill: "#CCCBFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.666 53.2363C229.728 50.7182 234.145 50.718 237.207 53.2363L363.243 156.865L231.936 264.827L100.631 156.865L226.666 53.2363Z",
    fill: "#61CB7C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.631 156.732L231.936 264.695L363.243 156.732V323.652C363.243 328.234 359.527 331.95 354.944 331.95H108.93C104.346 331.95 100.631 328.234 100.631 323.652V156.732Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M325.309 187.577V100.04C325.309 95.2052 321.39 91.2861 316.556 91.2861H147.317C142.483 91.2861 138.563 95.2052 138.563 100.04V187.577L226.292 261.597C229.551 264.348 234.321 264.348 237.58 261.597L325.309 187.577Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_395_153",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 138,
    y: 91,
    width: 188,
    height: 176
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M325.309 187.577V97.5102C325.309 94.0726 322.522 91.2861 319.085 91.2861H144.788C141.35 91.2861 138.563 94.0726 138.563 97.5102V187.577L231.937 266.361L325.309 187.577Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_395_153)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_395_153",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 153,
    y: 103,
    width: 156,
    height: 47
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M308.764 103.938H153.454V149.649H308.764V103.938Z",
    fill: "#E4E6E9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_395_153)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M308.764 103.938H153.454V149.649H308.764V103.938Z",
    fill: "#A9A6FF"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M208.533 159.744H153.349V259.718H208.533V159.744Z",
    fill: "#BBB9FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M171.95 201.522V415.506H191.403V201.522H171.95Z",
    fill: "#E69B00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M171.95 201.521L181.4 167.503C181.478 167.223 181.876 167.223 181.954 167.503L191.403 201.521H171.95Z",
    fill: "#2A3647"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M171.95 201.522L176.813 184.015H186.54L191.403 201.522H171.95Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M308.091 159.751H218.88V280.083H308.091V159.751Z",
    fill: "#E1E1FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M227.425 176.244H299.792",
    stroke: "#BBB9FF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M227.425 201.141H299.792",
    stroke: "#BBB9FF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M227.425 226.037H299.792",
    stroke: "#BBB9FF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M227.425 188.692H299.792",
    stroke: "#BBB9FF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M227.425 238.485H299.792",
    stroke: "#BBB9FF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M227.425 250.934H299.792",
    stroke: "#BBB9FF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M227.425 213.589H299.792",
    stroke: "#BBB9FF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M424.038 147.775C464.272 147.775 496.888 115.158 496.888 74.9244C496.888 34.6904 464.272 2.07422 424.038 2.07422C383.804 2.07422 351.188 34.6904 351.188 74.9244C351.188 115.158 383.804 147.775 424.038 147.775Z",
    fill: "white",
    stroke: "#CCCBFF",
    strokeWidth: 2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M424.273 31.4941C410.836 31.4941 399.941 42.3877 399.941 55.8255H448.605C448.605 42.3877 437.711 31.4941 424.273 31.4941ZM424.273 116.654H415.149C415.149 121.694 419.234 125.778 424.273 125.778C429.313 125.778 433.398 121.694 433.398 116.654H424.273Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M426.348 26.0023C427.825 25.2471 428.836 23.7106 428.836 21.938C428.836 19.4185 426.792 17.376 424.273 17.376C421.755 17.376 419.711 19.4185 419.711 21.938C419.711 23.7104 420.722 25.2469 422.199 26.0021V29.5C413.128 30.205 405.344 35.4928 401.157 43.0502H392.894C391.319 43.0502 390.041 44.3274 390.041 45.9029C390.041 47.4785 391.319 48.7556 392.894 48.7556H398.825C398.201 51.0059 397.867 53.377 397.867 55.8258V55.8337C393.253 56.0009 389.751 59.5121 389.166 63.7023C380.41 66.8054 375.377 76.1733 377.821 85.2988C378.118 86.4056 379.257 87.0625 380.363 86.766C381.471 86.4693 382.126 85.3318 381.83 84.2249C380.039 77.5415 383.462 70.6895 389.608 67.9878C389.649 68.1056 389.693 68.2231 389.74 68.3405L407.537 112.832C408.448 115.108 410.63 116.611 413.074 116.655C413.074 122.84 418.089 127.853 424.273 127.853C430.458 127.853 435.473 122.84 435.473 116.655C437.915 116.611 440.099 115.108 441.01 112.832L458.807 68.3405C458.854 68.2231 458.898 68.1056 458.939 67.988C465.083 70.6895 468.508 77.5415 466.715 84.2249C466.419 85.3318 467.076 86.4693 468.184 86.766C469.29 87.0625 470.427 86.4056 470.724 85.2988C473.17 76.1733 468.137 66.8056 459.381 63.7023C458.796 59.5121 455.294 56.0007 450.68 55.8337V55.8258C450.68 53.377 450.346 51.0059 449.722 48.7556H455.653C457.228 48.7556 458.506 47.4785 458.506 45.9029C458.506 44.3274 457.228 43.0502 455.653 43.0502H447.388C443.203 35.4928 435.419 30.205 426.348 29.5V26.0023ZM424.273 33.5691C435.865 33.5691 445.388 42.4318 446.435 53.7511H402.112C403.159 42.4318 412.68 33.5691 424.273 33.5691ZM424.273 123.704C421.101 123.704 418.421 121.61 417.535 118.729H424.273H431.012C430.126 121.61 427.444 123.704 424.273 123.704ZM413.628 50.5115C416.147 50.5115 418.19 48.4689 418.19 45.9492C418.19 43.4297 416.147 41.3872 413.628 41.3872C411.108 41.3872 409.066 43.4297 409.066 45.9492C409.066 48.4689 411.108 50.5115 413.628 50.5115ZM434.919 50.5115C437.437 50.5115 439.481 48.4689 439.481 45.9492C439.481 43.4297 437.437 41.3872 434.919 41.3872C432.398 41.3872 430.356 43.4297 430.356 45.9492C430.356 48.4689 432.398 50.5115 434.919 50.5115ZM460.172 96.1395C460.836 92.1152 464.612 89.3588 468.645 90.0536C472.668 90.7463 475.336 94.5932 474.674 98.6061C474.481 99.772 473.381 100.561 472.215 100.369C471.049 100.177 470.259 99.0762 470.452 97.9102C470.738 96.1677 469.574 94.5556 467.919 94.2706C466.276 93.9876 464.68 95.1042 464.394 96.8353C464.203 98.0013 463.101 98.7907 461.935 98.5984C460.769 98.4063 459.981 97.3054 460.172 96.1395ZM384.153 96.8355C383.867 95.1044 382.271 93.9878 380.628 94.2708C378.973 94.5558 377.809 96.1677 378.095 97.9104C378.288 99.0764 377.498 100.177 376.332 100.369C375.166 100.561 374.066 99.7722 373.873 98.6063C373.211 94.5934 375.881 90.7465 379.902 90.0538C383.935 89.359 387.711 92.1154 388.375 96.1397C388.566 97.3056 387.778 98.4065 386.612 98.5986C385.446 98.7909 384.344 98.0015 384.153 96.8355Z",
    fill: "#6861F2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M431.877 97.1973C431.877 101.397 428.473 104.801 424.274 104.801C420.074 104.801 416.67 101.397 416.67 97.1973C416.67 92.9981 420.074 89.5938 424.274 89.5938C428.473 89.5938 431.877 92.9981 431.877 97.1973Z",
    stroke: "white",
    strokeWidth: 2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M437.959 65.4912H410.587C408.067 65.4912 406.024 67.5337 406.024 70.0533C406.024 72.5729 408.067 74.6155 410.587 74.6155H437.959C440.479 74.6155 442.522 72.5729 442.522 70.0533C442.522 67.5337 440.479 65.4912 437.959 65.4912Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomatedCampaignsImg);
export default __webpack_public_path__ + "static/media/automated-campaigns-img.7abdc9fd7fb46aebe877ab31742aec1a.svg";
export { ForwardRef as ReactComponent };